import { render, staticRenderFns } from "./HojaDiagnosticoDescentralizadoComponente.vue?vue&type=template&id=db5f59ca&scoped=true"
import script from "./HojaDiagnosticoDescentralizadoComponente.vue?vue&type=script&lang=js"
export * from "./HojaDiagnosticoDescentralizadoComponente.vue?vue&type=script&lang=js"
import style0 from "./HojaDiagnosticoDescentralizadoComponente.vue?vue&type=style&index=0&id=db5f59ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f59ca",
  null
  
)

export default component.exports